"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ChangeLanguage = function (_a) {
    var isAuth = _a.isAuth, languages = _a.languages, _b = _a.variant, variant = _b === void 0 ? 'round' : _b;
    var lang = (0, next_intl_1.useLocale)();
    var changeLangRef = (0, react_1.useRef)(null);
    var getPageWithNewLang = (0, apps_shared_1.usePageWithNewLang)();
    var renderRoundVariant = function () { return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.changeLanguageWrapper), ref: changeLangRef }, lang
        ? languages.map(function (l) {
            return lang !== l.key ? (react_1.default.createElement("a", { key: l.key, href: getPageWithNewLang(l.key) },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.langWrapper },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.lang },
                        react_1.default.createElement(image_1.default, { key: l.key, src: "/img/langFlags/".concat(l.key, ".svg"), alt: lang, width: 28, height: 28 }))))) : (react_1.default.createElement("div", { key: l.key, className: "".concat(styles_module_scss_1.default.langWrapper, " ").concat(styles_module_scss_1.default.langWrapperActive) },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.lang },
                    react_1.default.createElement(image_1.default, { key: l.key, src: "/img/langFlags/".concat(l.key, ".svg"), alt: lang, width: 28, height: 28 }))));
        })
        : null)); };
    var renderPlainVariant = function () { return (react_1.default.createElement("div", { className: styles_module_scss_1.default.plain }, lang ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(image_1.default, { src: "/img/langFlags/".concat(lang, ".svg"), alt: lang, width: 30, height: 20, className: styles_module_scss_1.default.plainImg }),
        react_1.default.createElement("span", { className: styles_module_scss_1.default.plainCode }, lang),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", fill: "none" },
            react_1.default.createElement("path", { stroke: "currentColor", "stroke-width": "2", d: "M1.757 4.243 6 8.485l4.243-4.242" })))) : null)); };
    return variant === 'round' ? renderRoundVariant() : renderPlainVariant();
};
exports.default = ChangeLanguage;
